import styles from "./ImportedBadge.module.css";

/** Marks a row on the practice area page whose content an import has just brought across. */
export function ImportedBadge() {
  return <span className={styles.badge}>Imported</span>;
}
